import React from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "components/Common/ChartsDynamicColor"
import { useTranslation } from "react-i18next"

export const RevenueAndEarnings: React.FC = () => {
  const { t } = useTranslation()

  const spineareaChartColors = getChartColorsArray(
    '["--bs-primary", "--bs-success"]'
  )

  const series = [
    {
      name: t("dashboard_revenue"),
      data: [68, 55, 70, 62, 30, 90, 72, 92, 85, 35, 90, 78],
    },
    {
      name: t("dashboard_earnings"),
      data: [55, 50, 62, 58, 15, 72, 65, 80, 78, 20, 75, 65],
    },
  ]

  const options = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },

    colors: spineareaChartColors,
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  }

  return (
    <div className="d-flex flex-column gap-3">
      <h4 className="font-size-16 text-capitalize fw-semibold mb-4">
        {t("dashboard_revenueEarnings")}
      </h4>
      <div
        style={{
          boxShadow: "0px 1px 2px 0px #38414A26",
          backgroundColor: "#fff",
        }}
      >
        <ReactApexChart
          options={options as any}
          series={series}
          type="line"
          height="350"
        />
      </div>
    </div>
  )
}
